import TimeAgo from 'javascript-time-ago'
import fr from 'javascript-time-ago/locale/fr'

TimeAgo.addDefaultLocale(fr)

export const timeAgo = new TimeAgo('fr-FR')
